import { ATC_EXTERNAL_TOGGLE } from 'src/commons/constants';

/**
 * Pure predicate. `isInternalView` is passed in rather than read from
 * InternalChromeConfigContext here: this used to call
 * useInternalChromeConfigContext(), which made an innocuous-looking util into a
 * hook and let both callers invoke it conditionally, breaking hook ordering.
 */
export const canShowSalesAssistant = (
  userEmail: string,
  isInternalView: boolean | undefined,
): boolean => {
  const isInternalAndNotToggledExternal: boolean =
    !!isInternalView &&
    !(window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) == 'true');

  const isAmazonEmail = userEmail.toLowerCase().includes('amazon.');

  return isInternalAndNotToggledExternal && isAmazonEmail;
};

export const createMountProps = (
  amazonAlias: string,
  userName: string,
  chromeConfigContext,
) => {
  const applicationName =
    chromeConfigContext.config.applicationName || 'unknown';
  return {
    userAlias: amazonAlias,
    userName: userName,
    window: window.location.host,
    applicationName: applicationName,
  };
};
